import PERMISOS from "#constants/perfiles"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { UseHasPermission } from "#hooks/useHasPermission"
import { STATUS } from "#savings-fund/constants"
import { UseSavingsFundContext } from "#savings-fund/contexts/contexts"
import { savingsFundGet } from "#savings-fund/services/Api"
import { Skeleton } from "@mui/material"
import MUIDataTable from "mui-datatables"
import { useMemo } from "react"
import TableButtons from "./TableButtons"

export default function Table({ opciones }) {
	const params = useMemo(() => ({ status: opciones }), [opciones])
	const rh = UseHasPermission(PERMISOS.RH_ALL)
	const { reload } = UseSavingsFundContext()
	const {
		loading,
		data: savings,
		error,
	} = useApi(savingsFundGet, {
		autoFetch: true,
		params,
		reload,
	})
	const { solicitudes = [] } = savings || {}

	const columns = [
		{
			name: "id",
			label: "ID",
			options: {
				filter: false,
				sort: false,
				display: false,
			},
		},
		{
			name: "status_name",
			label: "Estado",
			options: {
				filter: false,
				sort: true,
				display: true,
			},
		},
		{
			name: "deduccion",
			label: "Deducción",
			options: {
				customBodyRender: (value) => {
					return `$ ${value.toLocaleString()}`
				},
				filter: true,
				sort: true,
			},
		},
		{
			name: "no_empleado",
			label: "N° Empleado",
			options: {
				filter: false,
				sort: true,
				display: rh,
			},
		},
		{
			name: "colaborador_name",
			label: "Colaborador",
			options: {
				filter: false,
				sort: true,
				display: rh,
			},
		},
		{
			name: "sucursal_name",
			label: "Sucursal",
			options: {
				filter: false,
				sort: true,
				display: rh,
			},
		},
		{
			name: "departamento_name",
			label: "Departamento",
			options: {
				filter: false,
				sort: true,
				display: rh,
			},
		},
		{
			name: "fecha_solicitud",
			label: "Fecha de Solicitud",
			options: {
				filter: true,
				sort: true,
			},
		},
		{
			name: "fecha_ingreso",
			label: "Fecha de Ingreso",
			options: {
				filter: true,
				sort: true,
			},
		},
		{
			name: "fecha_salida",
			label: "Fecha de Salida",
			options: {
				display: opciones === STATUS.SALIO,
				filter: true,
				sort: true,
			},
		},
		{
			name: "action",
			label: " ",
			options: {
				filter: false,
				sort: false,
				display: rh && opciones === STATUS.PROCESO,
				customBodyRender: (value, { rowIndex }) => {
					const saving = solicitudes[rowIndex]
					return <TableButtons saving_id={saving?.id} />
				},
			},
		},
	]
	const options = {
		textLabels: {
			body: {
				noMatch: "No hay solicitudes", // Cambia este mensaje
			},
		},
		search: rh,
		filter: rh,
		download: rh,
		print: false,
		viewColumns: false,
		selectableRows: "none",
	}
	if (loading) return <Skeleton variant="rectangular" width={"100%"} height={"70vh"} />
	if (error)
		return (
			<ErrorResponse
				error={
					<div>
						Ocurrió un error <br />
						{error?.response?.data?.message || error?.message}
					</div>
				}
			/>
		)

	return (
		<MUIDataTable title={""} data={solicitudes} columns={columns} options={options} />
	)
}
